var _path, _path2, _path3, _path4, _path5, _path6, _rect, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeightLifting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.8,310.6h-11.2c-9.5,0-17.3-7.7-17.3-17.3V104.3c0-9.5,7.7-17.3,17.3-17.3h11.2c9.5,0,17.3,7.7,17.3,17.3 v189.1C254.1,302.9,246.3,310.6,236.8,310.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1,288.2H180c-9.5,0-17.3-7.7-17.3-17.3V126.7c0-9.5,7.7-17.3,17.3-17.3h11.2c9.5,0,17.3,7.7,17.3,17.3 v144.2C208.4,280.4,200.6,288.2,191.1,288.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.7,221.6h-21.1c-5.9,0-10.7-4.8-10.7-10.7v-24.2c0-5.9,4.8-10.7,10.7-10.7h21.1V221.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M787.2,87h11.2c9.5,0,17.3,7.7,17.3,17.3v189.1c0,9.5-7.7,17.3-17.3,17.3h-11.2c-9.5,0-17.3-7.7-17.3-17.3 V104.3C769.9,94.7,777.7,87,787.2,87z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M832.9,109.4H844c9.5,0,17.3,7.7,17.3,17.3v144.2c0,9.5-7.7,17.3-17.3,17.3h-11.2c-9.5,0-17.3-7.7-17.3-17.3 V126.7C815.6,117.2,823.4,109.4,832.9,109.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M861.3,176h21.1c5.9,0,10.7,4.8,10.7,10.7v24.2c0,5.9-4.8,10.7-10.7,10.7h-21.1V176z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 254.1,
    y: 176,
    width: 515.9,
    height: 45.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M342.6,221.6h-44.8L410,498.2v99.6L337.2,903c-4.5,17.2,8.5,34,26.3,34c5.6,0,10.8-1.7,15.3-4.7 c4.4-3,7.9-7.3,10-12.4l106.2-267.2h7.1l106.2,267.2c4.1,10.3,14.1,17.1,25.2,17.1c15.4,0,27.2-12.6,27.2-27.1 c0-2.3-0.3-4.6-0.9-6.9l-72.8-305.3v-99.6l112.1-276.5h-44.8l-77.3,139.7c-34.2,61.8-123,61.8-157.2,0L342.6,221.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M498.5,370.9L498.5,370.9c-31,0-56.2-25.1-56.2-56.2v0c0-31,25.1-56.2,56.2-56.2h0c31,0,56.2,25.1,56.2,56.2v0 C554.7,345.7,529.5,370.9,498.5,370.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeightLifting);
export default __webpack_public_path__ + "static/media/WeightLifting.f1bb6863934e5e9b15cf5c3ffa149b81.svg";
export { ForwardRef as ReactComponent };